import React from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { CircularProgress, Button } from "@mui/material";
import * as Styled from "./styles";
import { getRandomId } from "../../../../../utils/helpers";

const MediaMasonry = ({
  content = [],
  isLoading = false,
  handleErrorMedia = () => {},
  onReplaceButtonPress = () => {},
  mediaType,
  loadingMediaItems = new Set(),
}) => {
  // Helper function to check if a URL is a GIF
  const isGifUrl = (url) => {
    if (!url) return false;
    return (
      url.toLowerCase().endsWith(".gif") || url.toLowerCase().includes("giphy")
    );
  };

  return (
    <>
      {isLoading && content?.length === 0 ? (
        <Styled.LoaderContainer>
          <CircularProgress size={24} />
        </Styled.LoaderContainer>
      ) : (
        <>
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
          >
            <Masonry>
              {content?.length &&
                content.map((media, i) => {
                  // Determine if this is a GIF that should autoplay
                  const isGif = isGifUrl(media.url);
                  const mediaUrl = media.url || media.src;
                  const isItemLoading = loadingMediaItems.has(mediaUrl);

                  return (
                    <Styled.ImageContainer key={i}>
                      {/* For GIFs, use the actual URL not the thumbnail to enable autoplay */}
                      <img
                        src={isGif ? media.url : media.thumbnail || media.url}
                        style={Styled.imageStyle}
                        alt={`${media.url || media.src}+${i}`}
                        onError={() => {
                          handleErrorMedia(media);
                        }}
                      />
                      <Styled.Overlay>
                        <Button
                          variant="contained"
                          disabled={isItemLoading}
                          sx={{
                            mb: "10px",
                            backgroundColor: "#FFFFFF",
                            fontFamily: "DM Sans",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "#123051",
                            height: "24px",
                            lineHeight: "20px",
                            textTransform: "none",
                            borderWidth: 1,
                            borderColor: "red",
                            width: "80%",
                            minWidth: "60px",
                          }}
                          onClick={() =>
                            onReplaceButtonPress({
                              ...media,
                              src: media.url || media.src,
                              id: getRandomId(),
                              title: media.title || "",
                            })
                          }
                        >
                          {isItemLoading ? (
                            <CircularProgress
                              size={16}
                              sx={{ color: "purple" }}
                            />
                          ) : (
                            "Replace"
                          )}
                        </Button>
                      </Styled.Overlay>
                    </Styled.ImageContainer>
                  );
                })}
            </Masonry>
          </ResponsiveMasonry>
          {isLoading && (
            <Styled.ProgressContainer>
              <CircularProgress size={24} />
            </Styled.ProgressContainer>
          )}
        </>
      )}
    </>
  );
};

export default MediaMasonry;
